import { Link } from "react-router-dom";
import CopyRight from "./CopyRight";

export default function FooterDetails() {
	return (
		<footer className="d-flex  pb-10 footer-details">
			<nav className="as">
				<h6>ِAbout</h6>
				<Link to="/about">About Us</Link>
				<Link to="/privacy-policy">Privacy Policy</Link>
				<Link to="/terms">Terms of Service</Link>
			</nav>
			<div>
				<h6>For Support and Inquiries</h6>
				<a href="mailto:support@givatake.com">support@givatake.com</a>
			</div>
			<div>
				<h6>Developer Contact</h6>
				<a href="mailto:battar.developer@gmail.com">battar.developer@gmail.com</a>
			</div>
			<div>
				<Link to={"/"}>go to home</Link>
				<CopyRight />
			</div>
		</footer>
	);
}
